import $ from "jquery";
import "bootstrap";
import { TweenMax, Linear } from 'gsap';

import initCarouselPage from './apps/carousel.js';
import initScrollMagic from './apps/scrollmagic.js';
import initT1Navigation from './apps/navigation.js';
import initUserInterface from './apps/userinterface.js';
import initVideoJsPage from './apps/video.js';
import initArticleFeed from './apps/articlefeed.js';
import initFaculty from './apps/faculty.js';
import initDegreesAndPrograms from './apps/degreesAndPrograms.js';
import initProgramFinder from './apps/programFinder.js';
import initNews from './apps/news.js';
import initEvents from './apps/events.js';
import initSearch from './apps/search.js';
import initCareers from './apps/careers.js';
import initCookieAlert from './apps/cookieAlert';

$( document ).ready(function() {

    // init scripts being imported
    initUserInterface();
    initCarouselPage();
    initScrollMagic();
    initT1Navigation();
    initVideoJsPage();
    initCookieAlert();

    if($("#articleFeed").length > 0){
        initArticleFeed();
    }
    if($("#facultyFinder").length > 0){
        initFaculty();
    }
    if($("#degreesAndProgramFinder").length > 0){
        initDegreesAndPrograms();
    }
    if($("#programFinder").length > 0){
        initProgramFinder();
    }
    if($("#newsListing").length > 0){
        initNews();
    }
    if($("#eventListing").length > 0){
        initEvents();
    }
    if($("#degreesAndProgramFinder").length > 0){
        initCareers();
    }

    initSearch();

    // console.log(window);
})



// WEBPACK FOOTER //
// ./src/ui/js/index.js